import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";

const controlAdapter = createEntityAdapter({
  selectId: (control) => control.id,
});

const emptyInitState = controlAdapter.getInitialState({ animation: "animate__fadeInRight", animationError: "animate__fadeInDown", currentStep: 0, showReturnDialog: false });
const fillState = controlAdapter.upsertOne(emptyInitState, {});

const controlSlice = createSlice({
  name: "control",
  initialState: fillState,
  reducers: {
    activeStep: (state, action) => {
      state.currentStep = action.payload.activeStep;
    },
    setAnimationClass: (state, action) => {
      state.animation = action.payload;
    },
    showReturnDialog: (state, action) => {
      state.showReturnDialog = action.payload;
    },
  },
});

//Selectors
export const controlSelectors = controlAdapter.getSelectors((state) => state.control);

//Select animation for error window className
export const animationClass = createSelector(
  (state) => state.control.animationError,
  (control) => control
);

export const activeStepSelector = createSelector(
  (state) => state.control.currentStep,
  (control) => control
);

export const returnDialogStateSelector = createSelector(
  (state) => state.control.showReturnDialog,
  (control) => control
);
export const { activeStep, setAnimationClass, showReturnDialog } = controlSlice.actions;
export default controlSlice.reducer;
